export default __webpack_public_path__ + "static/media/interpreting_1.b3224166.jpg";